import { CheckCircle } from '@material-ui/icons'
import styled, { ThemeProvider } from 'styled-components'

import theme from '../../utils/theme'

const StatusCheck = () => (
  <ThemeProvider theme={theme}>
    <StatusCheckDiv />
  </ThemeProvider>
)

const StatusCheckDiv = styled(CheckCircle)`
  && {
    font-size: 16px;
    margin: 0 2px;
    color: ${props => props.theme.colors.green};
  }
`

export default StatusCheck
